export const DESTINATION_CATALOG = [
  { country: 'Spain', region: 'Catalonia', city: 'Barcelona' },
  { country: 'Spain', region: 'Community of Madrid', city: 'Madrid' },
  { country: 'France', region: 'Ile-de-France', city: 'Paris' },
  { country: 'Italy', region: 'Lazio', city: 'Rome' },
  { country: 'United Kingdom', region: 'England', city: 'London' },
  { country: 'Germany', region: 'Berlin', city: 'Berlin' },
  { country: 'Portugal', region: 'Lisbon District', city: 'Lisbon' },
  { country: 'Netherlands', region: 'North Holland', city: 'Amsterdam' },
  { country: 'Greece', region: 'Attica', city: 'Athens' },
  { country: 'Turkey', region: 'Istanbul', city: 'Istanbul' },
  { country: 'Japan', region: 'Tokyo', city: 'Tokyo' },
  { country: 'Japan', region: 'Kyoto', city: 'Kyoto' },
  { country: 'Japan', region: 'Osaka', city: 'Osaka' },
  { country: 'South Korea', region: 'Seoul', city: 'Seoul' },
  { country: 'Thailand', region: 'Bangkok', city: 'Bangkok' },
  { country: 'Singapore', region: 'Central Region', city: 'Singapore' },
  { country: 'Vietnam', region: 'Hanoi', city: 'Hanoi' },
  { country: 'Vietnam', region: 'Ho Chi Minh City', city: 'Ho Chi Minh City' },
  { country: 'Australia', region: 'New South Wales', city: 'Sydney' },
  { country: 'Australia', region: 'Victoria', city: 'Melbourne' },
  { country: 'Canada', region: 'Ontario', city: 'Toronto' },
  { country: 'Canada', region: 'British Columbia', city: 'Vancouver' },
  { country: 'Mexico', region: 'Mexico City', city: 'Mexico City' },
  { country: 'Brazil', region: 'Rio de Janeiro', city: 'Rio de Janeiro' },
  { country: 'United Arab Emirates', region: 'Dubai', city: 'Dubai' },
  { country: 'India', region: 'Maharashtra', city: 'Mumbai' },
  { country: 'India', region: 'Delhi', city: 'New Delhi' },
  { country: 'United States', region: 'New York', city: 'New York City' },
  { country: 'United States', region: 'California', city: 'Los Angeles' },
  { country: 'United States', region: 'California', city: 'San Francisco' },
  { country: 'United States', region: 'Illinois', city: 'Chicago' },
  { country: 'United States', region: 'Massachusetts', city: 'Boston' },
  { country: 'United States', region: 'Florida', city: 'Miami' },
  { country: 'United States', region: 'Nevada', city: 'Las Vegas' },
  { country: 'United States', region: 'Washington', city: 'Seattle' },
];
